function truncateNumber(num, decimalPlaces = 2) {
    let regex = new RegExp("^-?\\d+(?:\\.\\d{0," + decimalPlaces + "})?");
    return parseFloat(regex.exec(num.toString())[0]);
}

function addMissingTrailingZerosToNumber(number) {
    let parts = number.toString().split('.');
    if (parts.length === 1) {
        return number;
    }
    return parts[0] + '.' + parts[1] + (parts[1].length === 1 ? '0' : '');
}

function formatAsCurrency(number, decimalPlaces = 2, truncateResult = false) {
    let numberToChosenPrecision = truncateResult
        ? truncateNumber(number, decimalPlaces)
        : parseFloat(number).toFixed(decimalPlaces);
    let parts = numberToChosenPrecision.toString().split('.');  
    let formattedWholePounds = parseInt(parts[0]).toLocaleString("en-GB");
    if (parts.length === 1) {
        // No decimal points
        return formattedWholePounds + '.00';
    }
    let trailingZeros = parts[1].length < decimalPlaces ? '0'.repeat(decimalPlaces - parts[1].length) : '';
    return (formattedWholePounds + '.' + parts[1] + trailingZeros).replace('.00', '')
}

function calculateInstalmentAmountsForLoan(loanAmount, interestRate, monthsInAgreement) {
    if (interestRate == '0') {
        let instalment = addMissingTrailingZerosToNumber(
            parseFloat((loanAmount / monthsInAgreement).toFixed(2))
        );

        return {
            'totalAmount': formatAsCurrency(loanAmount),
            'interestRate': "0.00",
            'monthlyInterestRate': 0,
            'numberOfMonths': monthsInAgreement,
            'firstInstalment': instalment,
            'regularMonthlyInstalment': formatAsCurrency(instalment, 2, true),
            'totalToPay': formatAsCurrency(loanAmount),
            'totalLoanValue': formatAsCurrency(loanAmount - instalment),
            'interest': formatAsCurrency(0),
            'effectiveTerm': monthsInAgreement - 1,
        }
    }

    // Calculate the monthly interest rate
    monthlyInterestRate = parseFloat((Math.pow((interestRate + 1), (1 / 12)) - 1).toFixed(6));

    // Establish the initial payment to be made by the customer
    // This is INTEREST FREE, and MUST be calculated in pence.
    loanAmountInPence = loanAmount * 100;
    initialRemainder = loanAmountInPence % monthsInAgreement;
    initialRegularInstalment = (loanAmountInPence - initialRemainder) / monthsInAgreement;
    firstInstalment = (initialRegularInstalment + initialRemainder) / 100;

    // The loan principle is the amount left after the initial payment has been made. This is the amount that is
    // actively being loaned, which will require interest
    loanPrincipal = loanAmount - firstInstalment;

    // Establish the monthly rate for this new loan principal amount, to be paid across one fewer instalments than
    // defined, as the first instalment has already been paid. 
    // This is required as we need to calculate interest on the slightly lower amount of the loan principle, not
    // against the amount of the original order.
    monthlyInstalment = parseFloat(
        (loanPrincipal * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, ((monthsInAgreement - 1) * -1))),
        6
    );

    // Calculate the total to be paid, and the interest that includes
    totalToPay = (monthlyInstalment * (monthsInAgreement - 1)) + firstInstalment;
    interestToPay = totalToPay - loanAmount;

    return {
        'totalAmount': loanAmount,
        'interestRate': addMissingTrailingZerosToNumber(interestRate * 100),
        'monthlyInterestRate': monthlyInterestRate,
        'numberOfMonths': monthsInAgreement,
        'firstInstalment': firstInstalment,
        'regularMonthlyInstalment': formatAsCurrency(monthlyInstalment, 2, true),
        'totalToPay': formatAsCurrency(totalToPay),
        'totalLoanValue': formatAsCurrency(totalToPay - firstInstalment),
        'interest': formatAsCurrency(interestToPay),
        'effectiveTerm': monthsInAgreement - 1,
    }
}

function getRepresentativeAprExampleHtml(exampleAmount, interestRate, numberOfMonths) {
    // Get the representative APR as a percentage
    var repAprExample = calculateInstalmentAmountsForLoan(exampleAmount, interestRate / 100, numberOfMonths);

    response = "<strong>Representative Example:</strong> A loan of £" + formatAsCurrency(exampleAmount) + " over " +
        numberOfMonths + " months" +
        " will cost you £" + repAprExample['regularMonthlyInstalment'] + " per months " +
        "at a representative " + parseFloat(interestRate).toFixed(2) + "% APR." +
        " The total cost after " + numberOfMonths + " months" +
        " is £" + repAprExample['totalToPay'] + ", " +
        "which includes £" + repAprExample['interest'] + " interest " +
        "at " + interestRate + "% fixed and a £0 fee. " +
        "The total amount of credit is £" + repAprExample['totalLoanValue'] + ".";
    return response;
}

function getTooltipData(valueToDisplay, instalments, retailerHasInterestBearingInstalment) {
    let tooltipHtml = '';
    let lowestMonthlyAmount = 0;
    let lowestMonthlyAmountInterestRate = 0;
    let highestNumberOfMonths = 1;

    tooltipHtml += '<div class="dividebuyTable">';
    tooltipHtml += '<div class="dividebuyTableBody">';
    tooltipHtml += '<div class="dividebuyTableRow dividebuyTableRowhead">';
    tooltipHtml += '<div class="dividebuyTableCell dividebuyTableCellmonth">Months</div>';
    tooltipHtml += '<div class="dividebuyTableCell">In Total<br />You’ll Pay</div>';
    if (retailerHasInterestBearingInstalment) {
        tooltipHtml += '<div class="dividebuyTableCell">Interest Rate<br />(Fixed)/APR</div>';
    }
    tooltipHtml += '<div class="dividebuyTableCell">Monthly Payment</div>';
    tooltipHtml += '</div>';

    // Function for generating tooltip content to be displayed in product page.
    for (value in instalments) {
        var months = instalments[value].key;
        var spendCost = instalments[value].value;
        var interestRate =  instalments[value].interest_rate / 100;
        var instalmentDetails = calculateInstalmentAmountsForLoan(valueToDisplay, interestRate, months);

        if (parseFloat(valueToDisplay) >= parseFloat(instalments[value].value)) {
          tooltipHtml += '<div class="dividebuyTableRow">';
          tooltipHtml += '<div class="dividebuyTableCell dividebuyTableCellmonth">' + months + '</div>';
          tooltipHtml += '<div class="dividebuyTableCell">£' + instalmentDetails['totalToPay'] + '</div>';
          if (retailerHasInterestBearingInstalment) {
            tooltipHtml += '<div class="dividebuyTableCell">' + instalmentDetails['interestRate'] + '%</div>';
          }
          tooltipHtml += '<div class="dividebuyTableCell">£' + instalmentDetails['regularMonthlyInstalment'] + '</div>';
          tooltipHtml += '</div>';

          // Store the lowest monthly amount, for use in the 'or from' display
          lowestMonthlyAmount = instalmentDetails['regularMonthlyInstalment'];
          lowestMonthlyAmountInterestRate = instalmentDetails['interestRate'];
          highestNumberOfMonths = instalmentDetails['numberOfMonths'];
        } else {
          tooltipHtml += '<div class="dividebuy-instalment dividebuy-instalment-disabled">';
          tooltipHtml += '<div class="dividebuy-spend-text"> Spend a minimum of £' + parseFloat(spendCost).toFixed(2) + ' to unlock: </div>';
          tooltipHtml += '<div class="dividebuy-monthly-instalments"> <span>' + months + ' </span>';
          tooltipHtml += 'payments of </div>';
          tooltipHtml += '<div class="dividebuy-installment-amount"> £' + (instalments[value].value / instalments[value].key).toFixed(2) + ' </div>';
          tooltipHtml += '</div>';
        }
    }

    tooltipHtml += '</div>';

    return {
        tooltipHtml,
        lowestMonthlyAmount,
        lowestMonthlyAmountInterestRate,
        highestNumberOfMonths
    };
}